import React, { useEffect, useState } from 'react';

export const MPT_AREA_SECTION_ITEM_ID = 'mpt_area_section';
export const MPT_ZK_ITEM_ID = 'mpt_zk_extracts';
export const MPT_LOKACIJSKA_INFORMACIJA_ITEM_ID = 'mpt_lokacijska_informacija';
export const MPT_IZRIS_E_PROSTOR_ITEM_ID = 'mpt_izris_e_prostor';
export const MPT_ACCESS_ITEM_ID = 'mpt_access';
export const MPT_NEIGHBOR_PARCELS_ITEM_ID = 'mpt_neighbor_parcels';
export const MPT_KOMUNALNI_PRISPEVEK_ITEM_ID = 'mpt_komunalni_prispevek';
export const MPT_ELECTRIC_NETWORK_ITEM_ID = 'mpt_electric_network';
export const MPT_WATER_NETWORK_ITEM_ID = 'mpt_water_network';
export const MPT_SEWER_NETWORK_ITEM_ID = 'mpt_sewer_network';
export const MPT_BOUNDARIES_ITEM_ID = 'mpt_urejene_meje';
export const MPT_GURS_IZPISI_ITEM_ID = 'mpt_gurs_izpisi';
export const MPT_GIS_IZPISI_ITEM_ID = 'mpt_gis_izpisi';
export const MPT_VREDNOTENJE_IZPISI_ITEM_ID = 'mpt_vrednotenje_izpisi';
export const MPT_ANALIZA_TRGA_ITEM_ID = 'mpt_analiza_trga';
export const MPT_OGLEDNICA_ITEM_ID = 'mpt_oglednica';
export const MPT_PREDSTAVITEV_PARCELE_ITEM_ID = 'mpt_predstavitev_parcele';
export const MPT_LINKI_ITEM_ID = 'mpt_linki';
export const MPT_OSTALI_DOKUMENTI_ITEM_ID = 'mpt_ostali_dokumenti';

export const MASTER_PARCEL_TEMPLATE_PRESET = {
  id: 'mpt',
  label: 'Master Parcel Template (MPT)',
  description: 'Hardcoded parcel-selling template with parcel extracts, utility fields, linked documents, and marketing materials.',
  locked: true,
  items: [
    { id: MPT_ZK_ITEM_ID, label: 'ZK izpiski', type: 'mpt_zk_extracts' },
    { id: MPT_LOKACIJSKA_INFORMACIJA_ITEM_ID, label: 'Lokacijska informacija', type: 'document' },
    { id: MPT_AREA_SECTION_ITEM_ID, label: 'površina, višina, naklon', type: 'mpt_area_section' },
    { id: MPT_ACCESS_ITEM_ID, label: 'Dostop', type: 'mpt_access' },
    { id: MPT_NEIGHBOR_PARCELS_ITEM_ID, label: 'Sosednje parcele', type: 'mpt_neighbor_parcels' },
    { id: MPT_KOMUNALNI_PRISPEVEK_ITEM_ID, label: 'Komunalni prispevek', type: 'mpt_komunalni_prispevek' },
    { id: MPT_ELECTRIC_NETWORK_ITEM_ID, label: 'Elektrika', type: 'mpt_electric_network' },
    { id: MPT_WATER_NETWORK_ITEM_ID, label: 'Vodovod', type: 'mpt_water_network' },
    { id: MPT_SEWER_NETWORK_ITEM_ID, label: 'Kanalizacija', type: 'mpt_sewer_network' },
    { id: MPT_BOUNDARIES_ITEM_ID, label: 'Urejene meje', type: 'mpt_urejene_meje' },
    { id: MPT_IZRIS_E_PROSTOR_ITEM_ID, label: 'Izris e-prostor', type: 'document' },
    { id: MPT_GURS_IZPISI_ITEM_ID, label: 'Gurs izpisi', type: 'mpt_gurs_izpisi' },
    { id: MPT_GIS_IZPISI_ITEM_ID, label: 'GIS izpisi', type: 'document' },
    { id: MPT_VREDNOTENJE_IZPISI_ITEM_ID, label: 'Izpisi iz evidence vrednotenja', type: 'mpt_vrednotenje_izpisi' },
    { id: MPT_ANALIZA_TRGA_ITEM_ID, label: 'Analiza trga', type: 'document' },
    { id: MPT_OGLEDNICA_ITEM_ID, label: 'Oglednica', type: 'document' },
    { id: MPT_PREDSTAVITEV_PARCELE_ITEM_ID, label: 'Predstavitev parcele', type: 'document' },
    { id: MPT_LINKI_ITEM_ID, label: 'Linki', type: 'mpt_linki' },
    { id: MPT_OSTALI_DOKUMENTI_ITEM_ID, label: 'Ostali dokumenti', type: 'mpt_ostali_dokumenti' }
  ]
};

const fieldStyle = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: '8px',
  border: '1px solid #dbe3ee',
  fontSize: '14px',
  color: '#334155',
  boxSizing: 'border-box',
  backgroundColor: '#ffffff'
};

const textAreaStyle = {
  ...fieldStyle,
  minHeight: '88px',
  resize: 'vertical'
};

const buttonStyle = {
  padding: '8px 12px',
  backgroundColor: '#0891b2',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontSize: '13px',
  fontWeight: '600'
};

const subtleCardStyle = {
  padding: '10px 12px',
  borderRadius: '8px',
  border: '1px solid #dbe3ee',
  backgroundColor: '#ffffff'
};

const parseNumberValue = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const normalized = String(value).replace(/\./g, '').replace(',', '.').trim();
  if (!normalized) return null;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

const computePricePerSquareMeter = ({ area, price }) => {
  const parsedArea = parseNumberValue(area);
  const parsedPrice = parseNumberValue(price);
  if (parsedArea === null || parsedPrice === null || parsedArea === 0) return null;
  return parsedPrice / parsedArea;
};

const computeHeightDifference = ({ minHeight, maxHeight }) => {
  const parsedMinHeight = parseNumberValue(minHeight);
  const parsedMaxHeight = parseNumberValue(maxHeight);
  if (parsedMinHeight === null || parsedMaxHeight === null) return null;
  return parsedMaxHeight - parsedMinHeight;
};

const normalizeText = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');

const normalizeDocumentValue = (value) => {
  const documentName = String(value?.documentName || '').trim();
  const documentPath = String(value?.documentPath || '').trim();
  if (!documentName || !documentPath) {
    return null;
  }
  return { documentName, documentPath };
};

const normalizeDocumentValues = (value) => {
  const legacyDocument = normalizeDocumentValue(value?.locationDocument || value?.document);
  const documents = Array.isArray(value?.locationDocuments)
    ? value.locationDocuments
    : Array.isArray(value?.documents)
      ? value.documents
      : legacyDocument
        ? [legacyDocument]
        : Array.isArray(value)
          ? value
          : [value];

  const normalizedDocuments = documents
    .map((documentValue) => normalizeDocumentValue(documentValue))
    .filter(Boolean);

  return normalizedDocuments;
};

const normalizeOwners = (owners) => Array.isArray(owners)
  ? owners.map((owner) => ({
      name: String(owner?.name || '').trim(),
      share: String(owner?.share || '').trim(),
      type: String(owner?.type || '').trim(),
      id: owner?.id ?? null,
      emso: owner?.emso ?? null,
      dateOfBirth: owner?.dateOfBirth ?? null,
      address: String(owner?.address || '').trim()
    })).filter((owner) => owner.name || owner.share || owner.address)
  : [];

const createEmptyParcelLookupValue = () => ({
  ko: '',
  parcela: '',
  notes: '',
  zkExtractId: null,
  ownerNames: '',
  owners: []
});

const createEmptyZkExtraParcel = () => ({
  ko: '',
  parcela: '',
  zkExtractId: null,
  ownerNames: ''
});

const createEmptyOtherDocument = () => ({
  name: '',
  document: null
});

const normalizeParcelLookupValue = (value) => ({
  ko: String(value?.ko || '').trim(),
  parcela: String(value?.parcela || '').trim(),
  notes: String(value?.notes || ''),
  zkExtractId: Number.isInteger(Number(value?.zkExtractId)) ? Number(value.zkExtractId) : null,
  ownerNames: String(value?.ownerNames || '').trim(),
  owners: normalizeOwners(value?.owners)
});

const normalizeZkExtraParcel = (value, fallbackKo = '') => ({
  ko: String(value?.ko || fallbackKo || '').trim(),
  parcela: String(value?.parcela || value?.secondaryIdParceleStavbe || '').trim(),
  zkExtractId: Number.isInteger(Number(value?.zkExtractId ?? value?.secondaryZkExtractId)) ? Number(value?.zkExtractId ?? value?.secondaryZkExtractId) : null,
  ownerNames: String(value?.ownerNames || value?.secondaryOwnerNames || '').trim()
});

const normalizeZkValue = (value, fallbackKo = '') => {
  const extraParcels = Array.isArray(value?.extraParcels)
    ? value.extraParcels.map((parcel) => normalizeZkExtraParcel(parcel, fallbackKo)).filter((parcel) => parcel.ko || parcel.parcela || parcel.zkExtractId || parcel.ownerNames)
    : [];

  if (extraParcels.length === 0 && (value?.secondaryKo || value?.secondaryIdParceleStavbe || value?.secondaryZkExtractId || value?.secondaryOwnerNames)) {
    extraParcels.push(normalizeZkExtraParcel({
      ko: value?.secondaryKo,
      parcela: value?.secondaryIdParceleStavbe,
      zkExtractId: value?.secondaryZkExtractId,
      ownerNames: value?.secondaryOwnerNames
    }, fallbackKo));
  }

  return {
    extraParcels
  };
};

const normalizeAreaSectionValue = (value) => ({
  area: String(value?.area || '').trim(),
  minHeight: String(value?.minHeight || '').trim(),
  maxHeight: String(value?.maxHeight || '').trim(),
  minSlope: String(value?.minSlope || '').trim(),
  maxSlope: String(value?.maxSlope || '').trim()
});

const normalizeAccessValue = (value) => {
  const parcels = Array.isArray(value?.parcels)
    ? value.parcels.map((parcel) => normalizeParcelLookupValue(parcel))
    : [];

  return {
    mode: String(value?.mode || '').trim(),
    notes: String(value?.notes || ''),
    ko: String(value?.ko || '').trim(),
    parcela: String(value?.parcela || '').trim(),
    municipalNotes: String(value?.municipalNotes || ''),
    municipalZkExtractId: Number.isInteger(Number(value?.municipalZkExtractId)) ? Number(value.municipalZkExtractId) : null,
    municipalOwnerNames: String(value?.municipalOwnerNames || '').trim(),
    parcels: parcels.length > 0 ? parcels : [createEmptyParcelLookupValue()]
  };
};

const normalizeNeighborParcelsValue = (value) => {
  const parcels = Array.isArray(value?.parcels)
    ? value.parcels.map((parcel) => normalizeParcelLookupValue(parcel))
    : [];

  return {
    parcels: parcels.length > 0 ? parcels : [createEmptyParcelLookupValue()]
  };
};

const normalizeKomunalniPrispevekValue = (value) => ({
  status: String(value?.status || '').trim(),
  house100: String(value?.house100 || ''),
  house150: String(value?.house150 || ''),
  customLabel: String(value?.customLabel || ''),
  customValue: String(value?.customValue || '')
});

const normalizeNetworkValue = (value) => ({
  hasConnection: value?.hasConnection === true,
  connectionPower: String(value?.connectionPower || ''),
  phase: String(value?.phase || '').trim(),
  manager: String(value?.manager || ''),
  location: String(value?.location || ''),
  locationDocuments: normalizeDocumentValues(value),
  notes: String(value?.notes || '')
});

const normalizeSewerNetworkValue = (value) => ({
  isNearby: value?.isNearby === true,
  location: String(value?.location || ''),
  notes: String(value?.notes || '')
});

const normalizeBoundariesValue = (value) => {
  if (value === true) {
    return {
      isChecked: true,
      notes: ''
    };
  }

  return {
    isChecked: value?.isChecked === true,
    notes: String(value?.notes || '')
  };
};

const normalizeLinkiValue = (value) => ({
  website: String(value?.website || ''),
  nepremicnine: String(value?.nepremicnine || ''),
  video: String(value?.video || '')
});

const normalizeOtherDocumentsValue = (value) => {
  const documents = Array.isArray(value?.documents) && value.documents.length > 0
    ? value.documents.map((entry) => ({
        name: String(entry?.name || ''),
        document: normalizeDocumentValue(entry?.document)
      }))
    : [];

  return {
    documents: documents.length > 0 ? documents : [createEmptyOtherDocument()]
  };
};

const normalizeParcelDocumentsValue = (value) => ({
  documents: Array.isArray(value?.documents)
    ? value.documents.map((entry) => ({
        parcelKey: String(entry?.parcelKey || ''),
        ko: String(entry?.ko || '').trim(),
        parcela: String(entry?.parcela || '').trim(),
        documents: normalizeDocumentValues(entry)
      }))
    : []
});

const buildMasterParcelList = (propertyForm, zkValue) => {
  const normalizedValue = normalizeZkValue(zkValue, propertyForm?.katastrskaObcina || '');
  return [
    {
      key: `primary:${propertyForm?.katastrskaObcina || ''}:${propertyForm?.idParceleStavbe || ''}`,
      ko: String(propertyForm?.katastrskaObcina || '').trim(),
      parcela: String(propertyForm?.idParceleStavbe || '').trim(),
      label: 'parcela 1',
      zkExtractId: propertyForm?.zkExtractId || null,
      ownerNames: ''
    },
    ...normalizedValue.extraParcels.map((parcel, index) => ({
      key: `extra:${parcel.ko}:${parcel.parcela}:${index}`,
      ko: parcel.ko,
      parcela: parcel.parcela,
      label: `parcela ${index + 2}`,
      zkExtractId: parcel.zkExtractId,
      ownerNames: parcel.ownerNames
    }))
  ].filter((parcel) => parcel.ko || parcel.parcela || parcel.zkExtractId);
};

const findMatchingPropertyContact = (owner, propertyContacts) => {
  const ownerName = normalizeText(owner?.name);
  const ownerAddress = normalizeText(owner?.address);
  if (!ownerName) {
    return null;
  }

  const nameMatches = (propertyContacts || []).filter((contact) => {
    const primaryName = normalizeText(contact?.contactName || contact?.name);
    const fallbackName = normalizeText(contact?.name);
    return primaryName === ownerName || fallbackName === ownerName;
  });

  if (nameMatches.length === 0) {
    return null;
  }

  if (ownerAddress) {
    const exactAddressMatch = nameMatches.find((contact) => normalizeText(contact?.address) === ownerAddress);
    if (exactAddressMatch) {
      return exactAddressMatch;
    }
  }

  return nameMatches[0];
};

const OwnerSummary = ({ owner, propertyContacts, onOpenPropertyContact, disableActions = false }) => {
  const matchedContact = findMatchingPropertyContact(owner, propertyContacts);
  const address = String(owner?.address || matchedContact?.address || '').trim();
  const phone = String(matchedContact?.phone || '').trim();
  const email = String(matchedContact?.email || '').trim();

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', alignItems: 'flex-start', flexWrap: 'wrap', paddingTop: '8px', borderTop: '1px solid #e2e8f0' }}>
      <div style={{ display: 'grid', gap: '4px', minWidth: '220px', flex: '1 1 220px' }}>
        <div style={{ color: '#1e293b', fontWeight: '600' }}>
          {owner.name || 'Unknown owner'}{owner.share ? ` (${owner.share})` : ''}
        </div>
        {address ? <div style={{ color: '#475569', fontSize: '13px' }}>Address: {address}</div> : null}
        {phone ? <div style={{ color: '#475569', fontSize: '13px' }}>Phone: {phone}</div> : null}
        {email ? <div style={{ color: '#475569', fontSize: '13px' }}>Email: {email}</div> : null}
      </div>
      {!disableActions && matchedContact?.id ? (
        <button type="button" onClick={() => onOpenPropertyContact?.(matchedContact)} style={{ ...buttonStyle, padding: '7px 10px', fontSize: '12px', backgroundColor: '#10b981' }}>
          contact
        </button>
      ) : null}
    </div>
  );
};

const ParcelOwnersSummary = ({ parcel, propertyContacts, onOpenPropertyContact, disableActions = false }) => {
  const owners = normalizeOwners(parcel?.owners);
  if (owners.length === 0) {
    return parcel?.ownerNames ? <div style={{ color: '#475569', marginTop: '6px' }}>Lastniki: {parcel.ownerNames}</div> : null;
  }

  return (
    <div style={{ display: 'grid', gap: '8px', marginTop: '10px' }}>
      {owners.map((owner, index) => (
        <OwnerSummary key={`${owner.name || 'owner'}-${owner.id || index}`} owner={owner} propertyContacts={propertyContacts} onOpenPropertyContact={onOpenPropertyContact} disableActions={disableActions} />
      ))}
    </div>
  );
};

const DocumentSummaryValue = ({ documentValue, downloadChecklistDocument, exportMode = false }) => {
  if (!documentValue) {
    return null;
  }

  if (exportMode) {
    return <div style={{ color: '#475569' }}>{documentValue.documentName}</div>;
  }

  return (
    <button type="button" onClick={() => downloadChecklistDocument?.(documentValue)} style={{ ...buttonStyle, width: 'fit-content', padding: '7px 10px', fontSize: '12px' }}>
      {documentValue.documentName}
    </button>
  );
};

const DocumentSummaryList = ({ documentValues, downloadChecklistDocument, exportMode = false }) => {
  const normalizedDocuments = normalizeDocumentValues(documentValues);
  if (normalizedDocuments.length === 0) {
    return null;
  }

  return (
    <div style={{ display: 'grid', gap: '8px' }}>
      {normalizedDocuments.map((documentValue, index) => (
        <DocumentSummaryValue
          key={`${documentValue.documentPath}-${index}`}
          documentValue={documentValue}
          downloadChecklistDocument={downloadChecklistDocument}
          exportMode={exportMode}
        />
      ))}
    </div>
  );
};

const ParcelLookupRow = ({ title, value, onChange, onRemove, fetchZkParcelData, downloadZkExtract, showRemove = false, includeNotes = true }) => {
  const [lookupState, setLookupState] = useState('idle');
  const lookupKey = `${value.ko}::${value.parcela}`;

  useEffect(() => {
    const ko = String(value.ko || '').trim();
    const parcela = String(value.parcela || '').trim();
    if (!ko || !parcela) {
      setLookupState('idle');
      if (value.zkExtractId || value.ownerNames || (Array.isArray(value.owners) && value.owners.length > 0)) {
        onChange({ ...value, zkExtractId: null, ownerNames: '', owners: [] });
      }
      return;
    }

    let cancelled = false;
    setLookupState('loading');

    fetchZkParcelData(ko, parcela)
      .then((data) => {
        if (cancelled) return;
        if (!data?.zkExtractId) {
          setLookupState('not-found');
          onChange({ ...value, zkExtractId: null, ownerNames: '', owners: [] });
          return;
        }

        setLookupState('resolved');
        onChange({
          ...value,
          zkExtractId: data.zkExtractId,
          ownerNames: data.ownerNames || '',
          owners: normalizeOwners(data.owners)
        });
      })
      .catch((error) => {
        if (cancelled) return;
        console.error('Error resolving parcel ZK data:', error);
        setLookupState('error');
        onChange({ ...value, zkExtractId: null, ownerNames: '', owners: [] });
      });

    return () => {
      cancelled = true;
    };
  }, [lookupKey, fetchZkParcelData]);

  return (
    <div style={{ display: 'grid', gap: '8px', ...subtleCardStyle }}>
      {title ? <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{title}</div> : null}
      <div style={{ display: 'grid', gap: '8px', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))' }}>
        <input value={value.ko} onChange={(event) => onChange({ ...value, ko: event.target.value, zkExtractId: null, ownerNames: '', owners: [] })} placeholder="KO" style={fieldStyle} />
        <input value={value.parcela} onChange={(event) => onChange({ ...value, parcela: event.target.value, zkExtractId: null, ownerNames: '', owners: [] })} placeholder="parcela" style={fieldStyle} />
      </div>
      {includeNotes ? <textarea value={value.notes} onChange={(event) => onChange({ ...value, notes: event.target.value })} placeholder="opombe" style={textAreaStyle} /> : null}
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ color: lookupState === 'error' ? '#b91c1c' : lookupState === 'not-found' ? '#b45309' : '#64748b', fontSize: '12px' }}>
          {lookupState === 'loading' ? 'Resolving ZK extract...' : null}
          {lookupState === 'not-found' ? 'No ZK extract found for this parcel.' : null}
          {lookupState === 'error' ? 'Failed to resolve ZK extract.' : null}
          {lookupState === 'resolved' && value.ownerNames ? `Lastniki: ${value.ownerNames}` : null}
        </div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {value.zkExtractId ? <button type="button" onClick={() => downloadZkExtract(value.zkExtractId, value.ko, value.parcela)} style={buttonStyle}>ZK extract</button> : null}
          {showRemove ? <button type="button" onClick={onRemove} style={{ ...buttonStyle, backgroundColor: '#dc2626' }}>Remove</button> : null}
        </div>
      </div>
    </div>
  );
};

const MasterParcelZkField = ({ value, setValue, propertyForm, fetchZkParcelData, downloadZkExtract, downloadZkHistory }) => {
  const normalizedValue = normalizeZkValue(value, propertyForm?.katastrskaObcina || '');

  const setParcelAtIndex = (index, nextParcel) => {
    const nextParcels = normalizedValue.extraParcels.map((parcel, parcelIndex) => (parcelIndex === index ? nextParcel : parcel));
    setValue({ extraParcels: nextParcels });
  };

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <div style={subtleCardStyle}>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>parcela 1</div>
        <div style={{ color: '#0f172a', fontWeight: '600', marginBottom: '8px' }}>{propertyForm?.katastrskaObcina} {propertyForm?.idParceleStavbe}</div>
        {propertyForm?.zkExtractId ? (
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <button type="button" onClick={() => downloadZkExtract(propertyForm.zkExtractId, propertyForm.katastrskaObcina, propertyForm.idParceleStavbe)} style={buttonStyle}>ZK extract</button>
            <button type="button" onClick={() => downloadZkHistory(propertyForm.zkExtractId, propertyForm.katastrskaObcina, propertyForm.idParceleStavbe)} style={{ ...buttonStyle, backgroundColor: '#0f766e' }}>ZK history</button>
          </div>
        ) : (
          <div style={{ color: '#94a3b8', fontSize: '13px' }}>No ZK extract linked for the primary parcel.</div>
        )}
      </div>

      <div style={{ display: 'grid', gap: '10px' }}>
        {normalizedValue.extraParcels.map((parcel, index) => (
          <ParcelLookupRow
            key={`mpt-zk-parcel-${index}`}
            title={`parcela ${index + 2}`}
            value={{ ...parcel, notes: '', owners: [] }}
            onChange={(nextParcel) => setParcelAtIndex(index, {
              ko: nextParcel.ko,
              parcela: nextParcel.parcela,
              zkExtractId: nextParcel.zkExtractId,
              ownerNames: nextParcel.ownerNames
            })}
            onRemove={() => setValue({ extraParcels: normalizedValue.extraParcels.filter((_, parcelIndex) => parcelIndex !== index) })}
            fetchZkParcelData={fetchZkParcelData}
            downloadZkExtract={downloadZkExtract}
            showRemove={normalizedValue.extraParcels.length > 1}
            includeNotes={false}
          />
        ))}
      </div>

      <div>
        <button type="button" onClick={() => setValue({ extraParcels: [...normalizedValue.extraParcels, createEmptyZkExtraParcel()] })} style={buttonStyle}>dodaj parcelo</button>
      </div>
    </div>
  );
};

const MasterParcelAreaSectionField = ({ value, setValue, price, formatEuro }) => {
  const normalizedValue = normalizeAreaSectionValue(value);
  const computedValue = computePricePerSquareMeter({ area: normalizedValue.area, price });
  const computedHeightDifference = computeHeightDifference({ minHeight: normalizedValue.minHeight, maxHeight: normalizedValue.maxHeight });

  const updateValue = (patch) => setValue({ ...normalizedValue, ...patch });

  return (
    <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
      <div>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Površina</div>
        <input value={normalizedValue.area} onChange={(event) => updateValue({ area: event.target.value })} placeholder="Vnesi površino" style={fieldStyle} />
      </div>
      <div>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>€/m2</div>
        <div style={{ ...subtleCardStyle, color: computedValue === null ? '#94a3b8' : '#0f172a', fontWeight: '600' }}>
          {computedValue === null ? 'Enter površina and property price.' : formatEuro(computedValue)}
        </div>
      </div>
      <div>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>min višina [m]</div>
        <input value={normalizedValue.minHeight} onChange={(event) => updateValue({ minHeight: event.target.value })} placeholder="Vnesi min višino" style={fieldStyle} />
      </div>
      <div>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>max višina [m]</div>
        <input value={normalizedValue.maxHeight} onChange={(event) => updateValue({ maxHeight: event.target.value })} placeholder="Vnesi max višino" style={fieldStyle} />
      </div>
      <div>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>razlika v višini</div>
        <div style={{ ...subtleCardStyle, color: computedHeightDifference === null ? '#94a3b8' : '#0f172a', fontWeight: '600' }}>
          {computedHeightDifference === null ? 'Enter min and max višina.' : computedHeightDifference}
        </div>
      </div>
      <div>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>max naklon [°]</div>
        <input value={normalizedValue.maxSlope} onChange={(event) => updateValue({ maxSlope: event.target.value })} placeholder="Vnesi max naklon" style={fieldStyle} />
      </div>
      <div>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>min naklon [°]</div>
        <input value={normalizedValue.minSlope} onChange={(event) => updateValue({ minSlope: event.target.value })} placeholder="Vnesi min naklon" style={fieldStyle} />
      </div>
    </div>
  );
};

const MasterParcelAccessField = ({ value, setValue, fetchZkParcelData, downloadZkExtract }) => {
  const normalizedValue = normalizeAccessValue(value);

  const setParcelAtIndex = (index, nextParcel) => {
    const nextParcels = normalizedValue.parcels.map((parcel, parcelIndex) => (parcelIndex === index ? nextParcel : parcel));
    setValue({ ...normalizedValue, parcels: nextParcels });
  };

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <select value={normalizedValue.mode} onChange={(event) => setValue({ ...normalizedValue, mode: event.target.value })} style={fieldStyle}>
        <option value="">Select access type</option>
        <option value="dostop ni urejen">dostop ni urejen</option>
        <option value="iz občinske parcele">iz občinske parcele</option>
        <option value="Preko parcel">Preko parcel</option>
      </select>

      {normalizedValue.mode === 'dostop ni urejen' ? <textarea value={normalizedValue.notes} onChange={(event) => setValue({ ...normalizedValue, notes: event.target.value })} placeholder="opombe" style={textAreaStyle} /> : null}

      {normalizedValue.mode === 'iz občinske parcele' ? (
        <ParcelLookupRow
          title="občinska parcela"
          value={{ ko: normalizedValue.ko, parcela: normalizedValue.parcela, notes: normalizedValue.municipalNotes, zkExtractId: normalizedValue.municipalZkExtractId, ownerNames: normalizedValue.municipalOwnerNames, owners: [] }}
          onChange={(nextParcel) => setValue({ ...normalizedValue, ko: nextParcel.ko, parcela: nextParcel.parcela, municipalNotes: nextParcel.notes, municipalZkExtractId: nextParcel.zkExtractId, municipalOwnerNames: nextParcel.ownerNames })}
          fetchZkParcelData={fetchZkParcelData}
          downloadZkExtract={downloadZkExtract}
        />
      ) : null}

      {normalizedValue.mode === 'Preko parcel' ? (
        <div style={{ display: 'grid', gap: '10px' }}>
          {normalizedValue.parcels.map((parcel, index) => (
            <ParcelLookupRow
              key={`access-parcel-${index}`}
              title={`parcela ${index + 1}`}
              value={parcel}
              onChange={(nextParcel) => setParcelAtIndex(index, nextParcel)}
              onRemove={() => setValue({ ...normalizedValue, parcels: normalizedValue.parcels.filter((_, parcelIndex) => parcelIndex !== index) })}
              fetchZkParcelData={fetchZkParcelData}
              downloadZkExtract={downloadZkExtract}
              showRemove={normalizedValue.parcels.length > 1}
            />
          ))}
          <div>
            <button type="button" onClick={() => setValue({ ...normalizedValue, parcels: [...normalizedValue.parcels, createEmptyParcelLookupValue()] })} style={buttonStyle}>dodaj parcelo</button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

const MasterParcelNeighborParcelsField = ({ value, setValue, fetchZkParcelData, downloadZkExtract }) => {
  const normalizedValue = normalizeNeighborParcelsValue(value);

  const setParcelAtIndex = (index, nextParcel) => {
    const nextParcels = normalizedValue.parcels.map((parcel, parcelIndex) => (parcelIndex === index ? nextParcel : parcel));
    setValue({ parcels: nextParcels });
  };

  return (
    <div style={{ display: 'grid', gap: '10px' }}>
      {normalizedValue.parcels.map((parcel, index) => (
        <ParcelLookupRow
          key={`neighbor-parcel-${index}`}
          title={`parcela ${index + 1}`}
          value={parcel}
          onChange={(nextParcel) => setParcelAtIndex(index, nextParcel)}
          onRemove={() => setValue({ parcels: normalizedValue.parcels.filter((_, parcelIndex) => parcelIndex !== index) })}
          fetchZkParcelData={fetchZkParcelData}
          downloadZkExtract={downloadZkExtract}
          showRemove={normalizedValue.parcels.length > 1}
        />
      ))}
      <div>
        <button type="button" onClick={() => setValue({ parcels: [...normalizedValue.parcels, createEmptyParcelLookupValue()] })} style={buttonStyle}>dodaj parcelo</button>
      </div>
    </div>
  );
};

const MasterParcelKomunalniPrispevekField = ({ value, setValue }) => {
  const normalizedValue = normalizeKomunalniPrispevekValue(value);

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <select value={normalizedValue.status} onChange={(event) => setValue({ ...normalizedValue, status: event.target.value })} style={fieldStyle}>
        <option value="">Select status</option>
        <option value="plačan">plačan</option>
        <option value="še ni plačan">še ni plačan</option>
      </select>

      {normalizedValue.status === 'še ni plačan' ? (
        <div style={{ display: 'grid', gap: '10px' }}>
          <div style={{ display: 'grid', gap: '6px' }}>
            <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>za 100 m2 hišo</div>
            <input value={normalizedValue.house100} onChange={(event) => setValue({ ...normalizedValue, house100: event.target.value })} placeholder="Vnesi vrednost" style={fieldStyle} />
          </div>
          <div style={{ display: 'grid', gap: '6px' }}>
            <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>za 150 m2 hišo</div>
            <input value={normalizedValue.house150} onChange={(event) => setValue({ ...normalizedValue, house150: event.target.value })} placeholder="Vnesi vrednost" style={fieldStyle} />
          </div>
          <div style={{ display: 'grid', gap: '8px', gridTemplateColumns: 'minmax(180px, 1fr) minmax(180px, 1fr)' }}>
            <input value={normalizedValue.customLabel} onChange={(event) => setValue({ ...normalizedValue, customLabel: event.target.value })} placeholder="Ime polja" style={fieldStyle} />
            <input value={normalizedValue.customValue} onChange={(event) => setValue({ ...normalizedValue, customValue: event.target.value })} placeholder="Vrednost" style={fieldStyle} />
          </div>
        </div>
      ) : null}
    </div>
  );
};

const UtilityNetworkField = ({ value, setValue, uploadChecklistDocument, downloadChecklistDocument, documentAccept, fileLabel, includeConnectionDetails }) => {
  const normalizedValue = normalizeNetworkValue(value);

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#0f172a', fontWeight: '500' }}>
        <input type="checkbox" checked={normalizedValue.hasConnection} onChange={(event) => setValue({ ...normalizedValue, hasConnection: event.target.checked })} />
        ima priključek
      </label>

      {normalizedValue.hasConnection && includeConnectionDetails ? (
        <div style={{ display: 'grid', gap: '10px', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
          <div style={{ display: 'grid', gap: '6px' }}>
            <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>priključna moč</div>
            <input value={normalizedValue.connectionPower} onChange={(event) => setValue({ ...normalizedValue, connectionPower: event.target.value })} placeholder="Vnesi priključno moč" style={fieldStyle} />
          </div>
          <div style={{ display: 'grid', gap: '6px' }}>
            <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>1 faza / 3 faze</div>
            <select value={normalizedValue.phase} onChange={(event) => setValue({ ...normalizedValue, phase: event.target.value })} style={fieldStyle}>
              <option value="">Izberi</option>
              <option value="1 faza">1 faza</option>
              <option value="3 faze">3 faze</option>
            </select>
          </div>
        </div>
      ) : null}

      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>upravitelj</div>
        <input value={normalizedValue.manager} onChange={(event) => setValue({ ...normalizedValue, manager: event.target.value })} placeholder="Vnesi upravitelja" style={fieldStyle} />
      </div>

      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>lokacija</div>
        <input value={normalizedValue.location} onChange={(event) => setValue({ ...normalizedValue, location: event.target.value })} placeholder="Vnesi lokacijo" style={fieldStyle} />
      </div>

      <div style={{ display: 'grid', gap: '8px' }}>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{fileLabel}</div>
        <input
          type="file"
          accept={documentAccept}
          multiple
          disabled={!uploadChecklistDocument}
          onChange={async (event) => {
            const files = Array.from(event.target.files || []);
            if (files.length > 0 && uploadChecklistDocument) {
              const uploadedDocuments = [];
              for (const file of files) {
                const nextDocument = await uploadChecklistDocument(file);
                if (nextDocument) {
                  uploadedDocuments.push(nextDocument);
                }
              }
              if (uploadedDocuments.length > 0) {
                setValue({ ...normalizedValue, locationDocuments: [...normalizedValue.locationDocuments, ...uploadedDocuments] });
              }
            }
            event.target.value = '';
          }}
          style={fieldStyle}
        />
        {normalizedValue.locationDocuments.length > 0 ? (
          <div style={{ display: 'grid', gap: '10px' }}>
            {normalizedValue.locationDocuments.map((documentValue, index) => (
              <div key={`${documentValue.documentPath}-${index}`} style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'center', padding: '10px 12px', backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #dbe3ee', flexWrap: 'wrap' }}>
                <div style={{ color: '#0f172a', fontWeight: '600' }}>{documentValue.documentName}</div>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <button type="button" onClick={() => downloadChecklistDocument?.(documentValue)} style={buttonStyle}>Download</button>
                  <button type="button" onClick={() => setValue({ ...normalizedValue, locationDocuments: normalizedValue.locationDocuments.filter((_, documentIndex) => documentIndex !== index) })} style={{ ...buttonStyle, backgroundColor: '#dc2626' }}>Remove</button>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>

      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>opombe</div>
        <textarea value={normalizedValue.notes} onChange={(event) => setValue({ ...normalizedValue, notes: event.target.value })} placeholder="Dodaj opombe" style={textAreaStyle} />
      </div>
    </div>
  );
};

const SewerNetworkField = ({ value, setValue }) => {
  const normalizedValue = normalizeSewerNetworkValue(value);

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#0f172a', fontWeight: '500' }}>
        <input type="checkbox" checked={normalizedValue.isNearby} onChange={(event) => setValue({ ...normalizedValue, isNearby: event.target.checked })} />
        je v bližini
      </label>

      {normalizedValue.isNearby ? (
        <div style={{ display: 'grid', gap: '6px' }}>
          <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>lokacija</div>
          <input value={normalizedValue.location} onChange={(event) => setValue({ ...normalizedValue, location: event.target.value })} placeholder="Vnesi lokacijo" style={fieldStyle} />
        </div>
      ) : null}

      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>opombe</div>
        <textarea value={normalizedValue.notes} onChange={(event) => setValue({ ...normalizedValue, notes: event.target.value })} placeholder="Dodaj opombe" style={textAreaStyle} />
      </div>
    </div>
  );
};

const BoundariesField = ({ value, setValue }) => {
  const normalizedValue = normalizeBoundariesValue(value);

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#0f172a', fontWeight: '500' }}>
        <input type="checkbox" checked={normalizedValue.isChecked} onChange={(event) => setValue({ ...normalizedValue, isChecked: event.target.checked })} />
        Urejene meje
      </label>

      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>opombe</div>
        <textarea value={normalizedValue.notes} onChange={(event) => setValue({ ...normalizedValue, notes: event.target.value })} placeholder="Dodaj opombe" style={textAreaStyle} />
      </div>
    </div>
  );
};

const ParcelDocumentsField = ({ value, setValue, parcels, uploadChecklistDocument, downloadChecklistDocument, documentAccept }) => {
  const normalizedValue = normalizeParcelDocumentsValue(value);
  const documents = parcels.map((parcel, index) => {
    const existing = normalizedValue.documents.find((entry) => (entry.ko && entry.parcela)
      ? entry.ko === parcel.ko && entry.parcela === parcel.parcela
      : entry.parcelKey === parcel.key) || normalizedValue.documents[index] || null;

    return {
      parcelKey: parcel.key,
      ko: parcel.ko,
      parcela: parcel.parcela,
      label: parcel.label,
      documents: normalizeDocumentValues(existing)
    };
  });

  return (
    <div style={{ display: 'grid', gap: '10px' }}>
      {documents.map((entry, index) => (
        <div key={`parcel-doc-${entry.parcelKey}-${index}`} style={subtleCardStyle}>
          <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{entry.label}</div>
          <div style={{ color: '#1e293b', fontWeight: '600', marginBottom: '10px' }}>{entry.ko || 'Unknown KO'} {entry.parcela || ''}</div>
          <input
            type="file"
            accept={documentAccept}
            multiple
            disabled={!uploadChecklistDocument}
            onChange={async (event) => {
              const files = Array.from(event.target.files || []);
              if (files.length > 0 && uploadChecklistDocument) {
                const uploadedDocuments = [];
                for (const file of files) {
                  const nextDocument = await uploadChecklistDocument(file);
                  if (nextDocument) {
                    uploadedDocuments.push(nextDocument);
                  }
                }
                if (uploadedDocuments.length > 0) {
                  const nextEntries = documents.map((candidate, candidateIndex) => candidateIndex === index
                    ? { ...candidate, documents: [...candidate.documents, ...uploadedDocuments] }
                    : candidate);
                  setValue({ documents: nextEntries.map(({ parcelKey, ko, parcela, documents: documentValues }) => ({ parcelKey, ko, parcela, documents: documentValues })) });
                }
              }
              event.target.value = '';
            }}
            style={fieldStyle}
          />
          {entry.documents.length > 0 ? (
            <div style={{ marginTop: '10px', display: 'grid', gap: '10px' }}>
              {entry.documents.map((documentValue, documentIndex) => (
                <div key={`${entry.parcelKey}-${documentValue.documentPath}-${documentIndex}`} style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <div style={{ color: '#0f172a', fontWeight: '600' }}>{documentValue.documentName}</div>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    <button type="button" onClick={() => downloadChecklistDocument?.(documentValue)} style={buttonStyle}>Download</button>
                    <button type="button" onClick={() => setValue({ documents: documents.map((candidate, candidateIndex) => candidateIndex === index ? { ...candidate, documents: candidate.documents.filter((_, candidateDocumentIndex) => candidateDocumentIndex !== documentIndex) } : candidate).map(({ parcelKey, ko, parcela, documents: documentValues }) => ({ parcelKey, ko, parcela, documents: documentValues })) })} style={{ ...buttonStyle, backgroundColor: '#dc2626' }}>Remove</button>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

const LinkiField = ({ value, setValue }) => {
  const normalizedValue = normalizeLinkiValue(value);
  return (
    <div style={{ display: 'grid', gap: '10px' }}>
      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>oglas spletna stran</div>
        <input value={normalizedValue.website} onChange={(event) => setValue({ ...normalizedValue, website: event.target.value })} placeholder="https://..." style={fieldStyle} />
      </div>
      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>oglas nepremicnine.net</div>
        <input value={normalizedValue.nepremicnine} onChange={(event) => setValue({ ...normalizedValue, nepremicnine: event.target.value })} placeholder="https://..." style={fieldStyle} />
      </div>
      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>video</div>
        <input value={normalizedValue.video} onChange={(event) => setValue({ ...normalizedValue, video: event.target.value })} placeholder="https://..." style={fieldStyle} />
      </div>
    </div>
  );
};

const OtherDocumentsField = ({ value, setValue, uploadChecklistDocument, downloadChecklistDocument, documentAccept }) => {
  const normalizedValue = normalizeOtherDocumentsValue(value);

  const setDocumentAtIndex = (index, nextDocument) => {
    const nextDocuments = normalizedValue.documents.map((entry, entryIndex) => entryIndex === index ? { ...entry, document: nextDocument } : entry);
    setValue({ documents: nextDocuments });
  };

  return (
    <div style={{ display: 'grid', gap: '10px' }}>
      {normalizedValue.documents.map((entry, index) => (
        <div key={`other-document-${index}`} style={subtleCardStyle}>
          <div style={{ display: 'grid', gap: '8px' }}>
            <input value={entry.name} onChange={(event) => setValue({ documents: normalizedValue.documents.map((candidate, candidateIndex) => candidateIndex === index ? { ...candidate, name: event.target.value } : candidate) })} placeholder="Ime dokumenta" style={fieldStyle} />
            <input
              type="file"
              accept={documentAccept}
              disabled={!uploadChecklistDocument}
              onChange={async (event) => {
                const file = event.target.files?.[0];
                if (file && uploadChecklistDocument) {
                  const nextDocument = await uploadChecklistDocument(file);
                  if (nextDocument) {
                    setDocumentAtIndex(index, nextDocument);
                  }
                }
                event.target.value = '';
              }}
              style={fieldStyle}
            />
            {entry.document ? (
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                <div style={{ color: '#0f172a', fontWeight: '600' }}>{entry.document.documentName}</div>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <button type="button" onClick={() => downloadChecklistDocument?.(entry.document)} style={buttonStyle}>Download</button>
                  <button type="button" onClick={() => setDocumentAtIndex(index, null)} style={{ ...buttonStyle, backgroundColor: '#dc2626' }}>Remove</button>
                </div>
              </div>
            ) : null}
            <div>
              <button type="button" onClick={() => setValue({ documents: normalizedValue.documents.filter((_, entryIndex) => entryIndex !== index).length > 0 ? normalizedValue.documents.filter((_, entryIndex) => entryIndex !== index) : [createEmptyOtherDocument()] })} style={{ ...buttonStyle, backgroundColor: '#dc2626' }}>Remove row</button>
            </div>
          </div>
        </div>
      ))}
      <div>
        <button type="button" onClick={() => setValue({ documents: [...normalizedValue.documents, createEmptyOtherDocument()] })} style={buttonStyle}>dodaj dokument</button>
      </div>
    </div>
  );
};

export const isMasterParcelChecklistItemFilled = ({ item, value, price }) => {
  if (item.type === 'mpt_zk_extracts') {
    return true;
  }
  if (item.type === 'mpt_area_section') {
    const normalizedValue = normalizeAreaSectionValue(value);
    return Boolean(
      normalizedValue.area
      || normalizedValue.minHeight
      || normalizedValue.maxHeight
      || normalizedValue.minSlope
      || normalizedValue.maxSlope
      || computePricePerSquareMeter({ area: normalizedValue.area, price }) !== null
      || computeHeightDifference({ minHeight: normalizedValue.minHeight, maxHeight: normalizedValue.maxHeight }) !== null
    );
  }
  if (item.type === 'mpt_access') {
    const normalizedValue = normalizeAccessValue(value);
    if (normalizedValue.mode === 'dostop ni urejen') return Boolean(normalizedValue.notes);
    if (normalizedValue.mode === 'iz občinske parcele') return Boolean(normalizedValue.ko || normalizedValue.parcela || normalizedValue.municipalNotes);
    if (normalizedValue.mode === 'Preko parcel') return normalizedValue.parcels.some((parcel) => parcel.ko || parcel.parcela || parcel.notes);
    return false;
  }
  if (item.type === 'mpt_neighbor_parcels') {
    const normalizedValue = normalizeNeighborParcelsValue(value);
    return normalizedValue.parcels.some((parcel) => parcel.ko || parcel.parcela || parcel.notes);
  }
  if (item.type === 'mpt_komunalni_prispevek') {
    const normalizedValue = normalizeKomunalniPrispevekValue(value);
    if (normalizedValue.status === 'plačan') return true;
    if (normalizedValue.status === 'še ni plačan') return Boolean(normalizedValue.house100 || normalizedValue.house150 || normalizedValue.customLabel || normalizedValue.customValue);
    return false;
  }
  if (item.type === 'mpt_electric_network' || item.type === 'mpt_water_network') {
    const normalizedValue = normalizeNetworkValue(value);
    return Boolean(normalizedValue.hasConnection || normalizedValue.connectionPower || normalizedValue.phase || normalizedValue.manager || normalizedValue.location || normalizedValue.locationDocuments.length > 0 || normalizedValue.notes);
  }
  if (item.type === 'mpt_sewer_network') {
    const normalizedValue = normalizeSewerNetworkValue(value);
    return Boolean(normalizedValue.isNearby || normalizedValue.location || normalizedValue.notes);
  }
  if (item.type === 'mpt_urejene_meje') {
    const normalizedValue = normalizeBoundariesValue(value);
    return Boolean(normalizedValue.isChecked || normalizedValue.notes);
  }
  if (item.type === 'mpt_gurs_izpisi' || item.type === 'mpt_vrednotenje_izpisi') {
    const normalizedValue = normalizeParcelDocumentsValue(value);
    return normalizedValue.documents.some((entry) => entry.documents.length > 0);
  }
  if (item.type === 'mpt_linki') {
    const normalizedValue = normalizeLinkiValue(value);
    return Boolean(normalizedValue.website || normalizedValue.nepremicnine || normalizedValue.video);
  }
  if (item.type === 'mpt_ostali_dokumenti') {
    const normalizedValue = normalizeOtherDocumentsValue(value);
    return normalizedValue.documents.some((entry) => entry.name || entry.document);
  }
  return false;
};

export const createMasterParcelCustomFieldRenderer = ({ propertyForm, fetchZkParcelData, downloadZkExtract, downloadZkHistory, formatEuro, uploadChecklistDocument, downloadChecklistDocument, documentAccept }) => ({ item, value, values, setValue }) => {
  if (item.type === 'mpt_zk_extracts') {
    return <MasterParcelZkField value={value} setValue={setValue} propertyForm={propertyForm} fetchZkParcelData={fetchZkParcelData} downloadZkExtract={downloadZkExtract} downloadZkHistory={downloadZkHistory} />;
  }
  if (item.type === 'mpt_area_section') {
    return <MasterParcelAreaSectionField value={value} setValue={setValue} price={propertyForm?.price} formatEuro={formatEuro} />;
  }
  if (item.type === 'mpt_access') {
    return <MasterParcelAccessField value={value} setValue={setValue} fetchZkParcelData={fetchZkParcelData} downloadZkExtract={downloadZkExtract} />;
  }
  if (item.type === 'mpt_neighbor_parcels') {
    return <MasterParcelNeighborParcelsField value={value} setValue={setValue} fetchZkParcelData={fetchZkParcelData} downloadZkExtract={downloadZkExtract} />;
  }
  if (item.type === 'mpt_komunalni_prispevek') {
    return <MasterParcelKomunalniPrispevekField value={value} setValue={setValue} />;
  }
  if (item.type === 'mpt_electric_network') {
    return <UtilityNetworkField value={value} setValue={setValue} uploadChecklistDocument={uploadChecklistDocument} downloadChecklistDocument={downloadChecklistDocument} documentAccept={documentAccept} fileLabel="prikaz lokacije električnega omrežja" includeConnectionDetails={true} />;
  }
  if (item.type === 'mpt_water_network') {
    return <UtilityNetworkField value={value} setValue={setValue} uploadChecklistDocument={uploadChecklistDocument} downloadChecklistDocument={downloadChecklistDocument} documentAccept={documentAccept} fileLabel="prikaz lokacije vodovoda" includeConnectionDetails={false} />;
  }
  if (item.type === 'mpt_sewer_network') {
    return <SewerNetworkField value={value} setValue={setValue} />;
  }
  if (item.type === 'mpt_urejene_meje') {
    return <BoundariesField value={value} setValue={setValue} />;
  }
  if (item.type === 'mpt_gurs_izpisi' || item.type === 'mpt_vrednotenje_izpisi') {
    return <ParcelDocumentsField value={value} setValue={setValue} parcels={buildMasterParcelList(propertyForm, values?.[MPT_ZK_ITEM_ID])} uploadChecklistDocument={uploadChecklistDocument} downloadChecklistDocument={downloadChecklistDocument} documentAccept={documentAccept} />;
  }
  if (item.type === 'mpt_linki') {
    return <LinkiField value={value} setValue={setValue} />;
  }
  if (item.type === 'mpt_ostali_dokumenti') {
    return <OtherDocumentsField value={value} setValue={setValue} uploadChecklistDocument={uploadChecklistDocument} downloadChecklistDocument={downloadChecklistDocument} documentAccept={documentAccept} />;
  }
  return null;
};

export const renderMasterParcelSummary = ({ item, value, propertyForm, price, formatEuro, downloadZkExtract, downloadZkHistory, downloadChecklistDocument, propertyContacts = [], onOpenPropertyContact, exportMode = false }) => {
  if (item.type === 'mpt_zk_extracts') {
    const parcels = buildMasterParcelList(propertyForm, value);
    return (
      <div style={{ display: 'grid', gap: '10px' }}>
        {parcels.map((parcel, index) => (
          <div key={`summary-zk-parcel-${parcel.key}-${index}`} style={subtleCardStyle}>
            <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{parcel.label}</div>
            <div style={{ color: '#1e293b', fontWeight: '600', marginBottom: '8px' }}>{parcel.ko} {parcel.parcela}</div>
            {parcel.ownerNames ? <div style={{ color: '#64748b', fontSize: '12px', marginBottom: '8px' }}>Lastniki: {parcel.ownerNames}</div> : null}
            {parcel.zkExtractId ? (
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {exportMode ? (
                  <div style={{ color: '#475569', fontSize: '13px' }}>ZK izpisek in ZK zgodovina sta na voljo</div>
                ) : (
                  <>
                    <button type="button" onClick={() => downloadZkExtract(parcel.zkExtractId, parcel.ko, parcel.parcela)} style={{ ...buttonStyle, padding: '7px 10px', fontSize: '12px' }}>ZK extract</button>
                    <button type="button" onClick={() => downloadZkHistory(parcel.zkExtractId, parcel.ko, parcel.parcela)} style={{ ...buttonStyle, padding: '7px 10px', fontSize: '12px', backgroundColor: '#0f766e' }}>ZK history</button>
                  </>
                )}
              </div>
            ) : <div style={{ color: '#94a3b8', fontSize: '13px' }}>No ZK extract linked for this parcel.</div>}
          </div>
        ))}
      </div>
    );
  }

  if (item.type === 'mpt_area_section') {
    const normalizedValue = normalizeAreaSectionValue(value);
    const computedValue = computePricePerSquareMeter({ area: normalizedValue.area, price });
    const computedHeightDifference = computeHeightDifference({ minHeight: normalizedValue.minHeight, maxHeight: normalizedValue.maxHeight });
    const summaryFields = [
      normalizedValue.area ? {
        label: 'Površina',
        value: normalizedValue.area
      } : null,
      computedValue !== null ? {
        label: '€/m2',
        value: formatEuro(computedValue)
      } : null,
      normalizedValue.minHeight ? {
        label: 'min višina [m]',
        value: normalizedValue.minHeight
      } : null,
      normalizedValue.maxHeight ? {
        label: 'max višina [m]',
        value: normalizedValue.maxHeight
      } : null,
      computedHeightDifference !== null ? {
        label: 'razlika v višini',
        value: computedHeightDifference
      } : null,
      normalizedValue.maxSlope ? {
        label: 'max naklon [°]',
        value: normalizedValue.maxSlope
      } : null,
      normalizedValue.minSlope ? {
        label: 'min naklon [°]',
        value: normalizedValue.minSlope
      } : null
    ].filter(Boolean);

    if (summaryFields.length === 0) {
      return <div style={{ color: '#94a3b8', fontSize: '13px' }}>Not set</div>;
    }

    return (
      <div style={{ display: 'grid', gap: '10px', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))' }}>
        {summaryFields.map((field) => (
          <div key={field.label}>
            <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{field.label}</div>
            <div style={{ color: '#1e293b', fontWeight: '600' }}>{field.value}</div>
          </div>
        ))}
      </div>
    );
  }

  if (item.type === 'mpt_access') {
    const normalizedValue = normalizeAccessValue(value);
    if (!normalizedValue.mode) return <div style={{ color: '#94a3b8', fontSize: '13px' }}>Not set</div>;
    if (normalizedValue.mode === 'dostop ni urejen') {
      return (
        <div style={{ display: 'grid', gap: '6px' }}>
          <div style={{ color: '#1e293b', fontWeight: '600' }}>{normalizedValue.mode}</div>
          {normalizedValue.notes ? <div style={{ color: '#475569', whiteSpace: 'pre-wrap' }}>Opombe: {normalizedValue.notes}</div> : null}
        </div>
      );
    }
    if (normalizedValue.mode === 'iz občinske parcele') {
      return (
        <div style={{ display: 'grid', gap: '6px' }}>
          <div style={{ color: '#1e293b', fontWeight: '600' }}>{normalizedValue.mode}</div>
          <div style={{ color: '#475569' }}>KO: {normalizedValue.ko || 'Not set'} | parcela: {normalizedValue.parcela || 'Not set'}</div>
          {normalizedValue.municipalNotes ? <div style={{ color: '#475569', whiteSpace: 'pre-wrap' }}>Opombe: {normalizedValue.municipalNotes}</div> : null}
          {normalizedValue.municipalOwnerNames ? <div style={{ color: '#475569', whiteSpace: 'pre-wrap' }}>Lastniki: {normalizedValue.municipalOwnerNames}</div> : null}
          {normalizedValue.municipalZkExtractId ? (exportMode ? <div style={{ color: '#475569' }}>ZK izpisek je na voljo</div> : <button type="button" onClick={() => downloadZkExtract(normalizedValue.municipalZkExtractId, normalizedValue.ko, normalizedValue.parcela)} style={{ ...buttonStyle, width: 'fit-content', padding: '7px 10px', fontSize: '12px' }}>ZK extract</button>) : null}
        </div>
      );
    }
    return (
      <div style={{ display: 'grid', gap: '10px' }}>
        <div style={{ color: '#1e293b', fontWeight: '600' }}>{normalizedValue.mode}</div>
        {normalizedValue.parcels.filter((parcel) => parcel.ko || parcel.parcela || parcel.notes).map((parcel, index) => (
          <div key={`summary-access-parcel-${index}`} style={subtleCardStyle}>
            <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px' }}>parcela {index + 1}</div>
            <div style={{ color: '#1e293b', fontWeight: '600' }}>{parcel.ko || 'Unknown KO'} {parcel.parcela || ''}</div>
            {parcel.ownerNames ? <div style={{ color: '#475569', marginTop: '6px' }}>Lastniki: {parcel.ownerNames}</div> : null}
            {parcel.notes ? <div style={{ color: '#475569', marginTop: '6px', whiteSpace: 'pre-wrap' }}>Opombe: {parcel.notes}</div> : null}
            {parcel.zkExtractId ? (exportMode ? <div style={{ color: '#475569', marginTop: '8px' }}>ZK izpisek je na voljo</div> : <button type="button" onClick={() => downloadZkExtract(parcel.zkExtractId, parcel.ko, parcel.parcela)} style={{ ...buttonStyle, marginTop: '8px', padding: '7px 10px', fontSize: '12px' }}>ZK extract</button>) : null}
          </div>
        ))}
      </div>
    );
  }

  if (item.type === 'mpt_neighbor_parcels') {
    const normalizedValue = normalizeNeighborParcelsValue(value);
    const filledParcels = normalizedValue.parcels.filter((parcel) => parcel.ko || parcel.parcela || parcel.notes);
    if (filledParcels.length === 0) return <div style={{ color: '#94a3b8', fontSize: '13px' }}>Not set</div>;
    return (
      <div style={{ display: 'grid', gap: '10px' }}>
        {filledParcels.map((parcel, index) => (
          <div key={`summary-neighbor-parcel-${index}`} style={subtleCardStyle}>
            <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px' }}>parcela {index + 1}</div>
            <div style={{ color: '#1e293b', fontWeight: '600' }}>{parcel.ko || 'Unknown KO'} {parcel.parcela || ''}</div>
            {parcel.notes ? <div style={{ color: '#475569', marginTop: '6px', whiteSpace: 'pre-wrap' }}>Opombe: {parcel.notes}</div> : null}
            {parcel.zkExtractId ? (exportMode ? <div style={{ color: '#475569', marginTop: '8px' }}>ZK izpisek je na voljo</div> : <button type="button" onClick={() => downloadZkExtract(parcel.zkExtractId, parcel.ko, parcel.parcela)} style={{ ...buttonStyle, marginTop: '8px', padding: '7px 10px', fontSize: '12px' }}>ZK extract</button>) : null}
            <ParcelOwnersSummary parcel={parcel} propertyContacts={propertyContacts} onOpenPropertyContact={onOpenPropertyContact} disableActions={exportMode} />
          </div>
        ))}
      </div>
    );
  }

  if (item.type === 'mpt_komunalni_prispevek') {
    const normalizedValue = normalizeKomunalniPrispevekValue(value);
    if (!normalizedValue.status) return <div style={{ color: '#94a3b8', fontSize: '13px' }}>Not set</div>;
    if (normalizedValue.status === 'plačan') return <div style={{ color: '#1e293b', fontWeight: '600' }}>plačan</div>;
    return (
      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#1e293b', fontWeight: '600' }}>{normalizedValue.status}</div>
        {normalizedValue.house100 ? <div style={{ color: '#475569' }}>za 100 m2 hišo: {normalizedValue.house100}</div> : null}
        {normalizedValue.house150 ? <div style={{ color: '#475569' }}>za 150 m2 hišo: {normalizedValue.house150}</div> : null}
        {normalizedValue.customLabel || normalizedValue.customValue ? <div style={{ color: '#475569' }}>{normalizedValue.customLabel || 'Custom'}: {normalizedValue.customValue || 'Not set'}</div> : null}
      </div>
    );
  }

  if (item.type === 'mpt_electric_network' || item.type === 'mpt_water_network') {
    const normalizedValue = normalizeNetworkValue(value);
    if (!normalizedValue.hasConnection && !normalizedValue.manager && !normalizedValue.location && normalizedValue.locationDocuments.length === 0 && !normalizedValue.notes) return <div style={{ color: '#94a3b8', fontSize: '13px' }}>Not set</div>;
    return (
      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#1e293b', fontWeight: '600' }}>{normalizedValue.hasConnection ? 'ima priključek' : 'nima priključka'}</div>
        {item.type === 'mpt_electric_network' && normalizedValue.hasConnection && normalizedValue.connectionPower ? <div style={{ color: '#475569' }}>priključna moč: {normalizedValue.connectionPower}</div> : null}
        {item.type === 'mpt_electric_network' && normalizedValue.hasConnection && normalizedValue.phase ? <div style={{ color: '#475569' }}>{normalizedValue.phase}</div> : null}
        {normalizedValue.manager ? <div style={{ color: '#475569' }}>upravitelj: {normalizedValue.manager}</div> : null}
        {normalizedValue.location ? <div style={{ color: '#475569' }}>lokacija: {normalizedValue.location}</div> : null}
        <DocumentSummaryList documentValues={normalizedValue.locationDocuments} downloadChecklistDocument={downloadChecklistDocument} exportMode={exportMode} />
        {normalizedValue.notes ? <div style={{ color: '#475569', whiteSpace: 'pre-wrap' }}>Opombe: {normalizedValue.notes}</div> : null}
      </div>
    );
  }

  if (item.type === 'mpt_sewer_network') {
    const normalizedValue = normalizeSewerNetworkValue(value);
    if (!normalizedValue.isNearby && !normalizedValue.location && !normalizedValue.notes) return <div style={{ color: '#94a3b8', fontSize: '13px' }}>Not set</div>;
    return (
      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#1e293b', fontWeight: '600' }}>{normalizedValue.isNearby ? 'je v bližini' : 'ni v bližini'}</div>
        {normalizedValue.isNearby && normalizedValue.location ? <div style={{ color: '#475569' }}>lokacija: {normalizedValue.location}</div> : null}
        {normalizedValue.notes ? <div style={{ color: '#475569', whiteSpace: 'pre-wrap' }}>Opombe: {normalizedValue.notes}</div> : null}
      </div>
    );
  }

  if (item.type === 'mpt_urejene_meje') {
    const normalizedValue = normalizeBoundariesValue(value);
    if (!normalizedValue.isChecked && !normalizedValue.notes) return <div style={{ color: '#94a3b8', fontSize: '13px' }}>Not set</div>;
    return (
      <div style={{ display: 'grid', gap: '6px' }}>
        <div style={{ color: '#1e293b', fontWeight: '600' }}>{normalizedValue.isChecked ? 'Urejene meje' : 'Ni označeno'}</div>
        {normalizedValue.notes ? <div style={{ color: '#475569', whiteSpace: 'pre-wrap' }}>Opombe: {normalizedValue.notes}</div> : null}
      </div>
    );
  }

  if (item.type === 'mpt_gurs_izpisi' || item.type === 'mpt_vrednotenje_izpisi') {
    const normalizedValue = normalizeParcelDocumentsValue(value);
    const filledEntries = normalizedValue.documents.filter((entry) => entry.documents.length > 0);
    if (filledEntries.length === 0) return <div style={{ color: '#94a3b8', fontSize: '13px' }}>Not set</div>;
    return (
      <div style={{ display: 'grid', gap: '10px' }}>
        {filledEntries.map((entry, index) => (
          <div key={`summary-parcel-document-${index}`} style={subtleCardStyle}>
            <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px' }}>{entry.ko} {entry.parcela}</div>
            <DocumentSummaryList documentValues={entry.documents} downloadChecklistDocument={downloadChecklistDocument} exportMode={exportMode} />
          </div>
        ))}
      </div>
    );
  }

  if (item.type === 'mpt_linki') {
    const normalizedValue = normalizeLinkiValue(value);
    if (!normalizedValue.website && !normalizedValue.nepremicnine && !normalizedValue.video) return <div style={{ color: '#94a3b8', fontSize: '13px' }}>Not set</div>;
    return (
      <div style={{ display: 'grid', gap: '6px' }}>
        {normalizedValue.website ? <div style={{ color: '#475569' }}>oglas spletna stran: {normalizedValue.website}</div> : null}
        {normalizedValue.nepremicnine ? <div style={{ color: '#475569' }}>oglas nepremicnine.net: {normalizedValue.nepremicnine}</div> : null}
        {normalizedValue.video ? <div style={{ color: '#475569' }}>video: {normalizedValue.video}</div> : null}
      </div>
    );
  }

  if (item.type === 'mpt_ostali_dokumenti') {
    const normalizedValue = normalizeOtherDocumentsValue(value);
    const filledEntries = normalizedValue.documents.filter((entry) => entry.name || entry.document);
    if (filledEntries.length === 0) return <div style={{ color: '#94a3b8', fontSize: '13px' }}>Not set</div>;
    return (
      <div style={{ display: 'grid', gap: '10px' }}>
        {filledEntries.map((entry, index) => (
          <div key={`summary-other-document-${index}`} style={subtleCardStyle}>
            <div style={{ color: '#475569', fontSize: '12px', fontWeight: '700', marginBottom: '6px' }}>{entry.name || 'Unnamed document'}</div>
            {entry.document ? <DocumentSummaryValue documentValue={entry.document} downloadChecklistDocument={downloadChecklistDocument} exportMode={exportMode} /> : null}
          </div>
        ))}
      </div>
    );
  }

  return null;
};
